import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import {  toast } from 'react-toastify';
import '../../../assets/style/style.css';
import CircularProgress from '@mui/material/CircularProgress';
import { useParams, useNavigate } from 'react-router-dom';
import Config from "../../../config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { handleErrors } from "common.js";
import { TextField } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';

function ReverseFulfillments(props) {
  const { returnID, openReverseFulfillmentModel, setPageContent, setIsLoading, setOpenReverseFulfillmentModel } =  props;  
  const navigate   = useNavigate();
  const { t }     = useTranslation();
  const baseUrl  = Config.baseUrl;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [shipmentSubmitIsLoading, setShipmentSubmitIsLoading] = useState(false);

  const [shipmentLength, setShipmentLength] = useState("");
  const [shipmentWeight, setShipmentWeight] = useState("");
  const [shipmentWidth, setShipmentWidth] = useState("");
  const [shipmentHeight, setShipmentHeight] = useState("");  

  const [shipmentLengthError, setShipmentLengthError] = useState(false);
  const [shipmentWeightError, setShipmentWeightError] = useState(false);
  const [shipmentWidthError, setShipmentWidthError] = useState(false);
  const [shipmentHeightError, setShipmentHeightError] = useState(false);

  const [shipmentLengthHelperText, setShipmentLengthHelperText] = useState('');
  const [shipmentWeightHelperText, setShipmentWeightHelperText] = useState('');
  const [shipmentWidthHelperText, setShipmentWidthHelperText] = useState('');
  const [shipmentHeightHelperText, setShipmentHeightHelperText] = useState('');
           
  const handleReverseFulfillmentModelClose = () => { setOpenReverseFulfillmentModel(false) };

  const handleChangeShipmentLength = (event) => {
    setShipmentLength(event.target.value);
    setShipmentLengthError(false);
    setShipmentLengthHelperText('');
  };

  const handleChangeShipmentWeight = (event) => {
    setShipmentWeight(event.target.value);
    setShipmentWeightError(false);
    setShipmentWeightHelperText('');
  };

  const handleChangeShipmentWidth = (event) => {
    setShipmentWidth(event.target.value);
    setShipmentWidthError(false);
    setShipmentWidthHelperText('');
  };

  const handleChangeShipmentHeight = (event) => {
    setShipmentHeight(event.target.value);
    setShipmentHeightError(false);
    setShipmentHeightHelperText('');
  };

  const handleShipmentSubmit = () => {
    
    if(!(parseFloat(shipmentWeight) > 0))
    {
        setShipmentWeightError(true);
        setShipmentWeightHelperText(t("Please enter the shipment weight"));
        return;
    }

    if(!(parseFloat(shipmentLength) > 0))
    {
        setShipmentLengthError(true);
        setShipmentLengthHelperText(t("Please enter the shipment length"));
        return;
    }

    if(!(parseFloat(shipmentWidth) > 0))
    {
        setShipmentWidthError(true);
        setShipmentWidthHelperText(t("Please enter the shipment width"));
        return;
    }

    if(!(parseFloat(shipmentHeight) > 0))
    {
        setShipmentHeightError(true);
        setShipmentHeightHelperText(t("Please enter the shipment height"));
        return;
    }    

    let requestPayLoad = { 
                            returnID: returnID, 
                            shipmentLength: parseFloat(shipmentLength),
                            shipmentWeight: parseFloat(shipmentWeight),
                            shipmentWidth: parseFloat(shipmentWidth),
                            shipmentHeight: parseFloat(shipmentHeight),
                         };

    setShipmentSubmitIsLoading(true);
    axios({      
          url     : baseUrl+"/return/create-reverse-delivery",
          data    : requestPayLoad,
          method  : "POST",
          headers : {
            Authorization   : bearerToken,
            function        : Config.FUNCTION_KEY
          },        
        }).then(function (response) 
        {
            setShipmentSubmitIsLoading(false);       

            const responseData           = response.data;
            const responseDataStatusCode = responseData.status ? responseData.status : 0;
            const responseMessage        = responseData.message ? responseData.message : '';
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {                
                (responseDataStatusCode === 1) ? toast.success(t(responseMessage)) : toast.error(t(responseMessage));
                    
                if(responseDataStatusCode === 1 && responseData && responseData.data)
                {
                  handleReverseFulfillmentModelClose();
                  setPageContent(responseData.data);
                }
            }        
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }   
        }).catch(function (error) {
          setShipmentSubmitIsLoading(false);  
          handleErrors(error, t, navigate);
        });
  }
  
  const reverseFulfillmentModelLoad = () => {
    return (
        <Dialog open={openReverseFulfillmentModel} onClose={handleReverseFulfillmentModelClose}
          sx={{
            '& .MuiDialog-paper': {
              maxWidth: '700px', 
            },
          }}
        >
          <DialogTitle id="sync-orders-dialog" onClose={handleReverseFulfillmentModelClose}>
            {t("Reverse Fulfillments")}  
          </DialogTitle>         
          <DialogContent dividers>           

            <Grid container spacing={2} my={1}>
                <Grid item sm={6} xs={12}>
                    <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                      <TextField 
                        type = "number"
                        label = {t('Weight (Grams)')}
                        variant = "outlined" 
                        value = {shipmentWeight}
                        inputProps={{
                          min: 0,
                        }}
                        onChange={handleChangeShipmentWeight}
                        error={shipmentWeightError}
                        required
                      />
                      <FormHelperText sx={{ position: 'absolute', bottom: -20, right: 0, color: 'red' }}>
                        {shipmentWeightHelperText}
                      </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item sm={6} xs={12}>
                    <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                      <TextField 
                        type = "number"
                        label = {t('Shipment Length (CM)')}
                        variant = "outlined" 
                        value = {shipmentLength}
                        inputProps={{
                          min: 0,
                        }}
                        onChange={handleChangeShipmentLength}   
                        error={shipmentLengthError}
                        required
                      />
                      <FormHelperText sx={{ position: 'absolute', bottom: -20, right: 0, color: 'red' }}>
                        {shipmentLengthHelperText}
                      </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item sm={6} xs={12}>
                    <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                      <TextField 
                        type = "number"
                        label = {t('Shipment Width (CM)')}
                        variant = "outlined" 
                        value = {shipmentWidth}
                        inputProps={{
                          min: 0,
                        }}
                        onChange={handleChangeShipmentWidth}   
                        error={shipmentWidthError}
                        required
                      />
                      <FormHelperText sx={{ position: 'absolute', bottom: -20, right: 0, color: 'red' }}>
                        {shipmentWidthHelperText}
                      </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item sm={6} xs={12}>
                    <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                      <TextField 
                        type = "number"
                        label = {t('Shipment Height (CM)')}
                        variant = "outlined" 
                        value = {shipmentHeight}
                        inputProps={{
                          min: 0,
                        }}
                        onChange={handleChangeShipmentHeight} 
                        error={shipmentHeightError}
                        required
                      />
                      <FormHelperText sx={{ position: 'absolute', bottom: -20, right: 0, color: 'red' }}>
                        {shipmentHeightHelperText}
                      </FormHelperText>
                    </FormControl>
                </Grid>
              </Grid>  
              
          <Container className="buttonContainer">
            <Box>
              <Button key={"button-1"}                    
                variant="contained" 
                sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                onClick={handleShipmentSubmit}
                disabled={shipmentSubmitIsLoading}>
                {t("Submit")}                    
              </Button>
              <Button key={"button-2"}                     
                variant="contained" 
                sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                onClick={handleReverseFulfillmentModelClose}
                disabled={shipmentSubmitIsLoading}>
                {t("close")}                    
              </Button>

              {shipmentSubmitIsLoading ?       
              <Box className='circularLoadingModelOuter'>   
                <CircularProgress size={30} className='circularLoadingModel' />
              </Box>
            : <></>}
            </Box>
        </Container>
      </DialogContent>
    </Dialog>  
    );
  }

  return (
          <>
          {reverseFulfillmentModelLoad()}
          </>
         );
}
export default ReverseFulfillments;
